export default __webpack_public_path__ + "i18n/zh-TW.28fa57055d3d412ac13be0f7b9de97d1.json";